import { createContext, useContext } from "react";
import type { ApiError } from "../../../api/ApiClient";

export type Reset = () => void;

export interface IHeaderWithProgressContext {
  isSaving: boolean;
  setIsSaving(): Reset;
  hasSaved: boolean;
  saveError: ApiError | null;
  setSaveError(saveError: ApiError | null): void;
  progress: number;
}

export const HeaderWithProgressContext =
  createContext<IHeaderWithProgressContext | null>(null);

export function useHeaderWithProgressContext() {
  const headerWithProgressContext = useContext(HeaderWithProgressContext);

  if (!headerWithProgressContext)
    throw new Error("No HeaderWithProgressContext found!");

  return headerWithProgressContext;
}
